export default __webpack_public_path__ + "static/media/Group27.cd2e18f1.png";